import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AddonService } from './api/addon.service';
import { AdminService } from './api/admin.service';
import { BannerService } from './api/banner.service';
import { CartService } from './api/cart.service';
import { CityService } from './api/city.service';
import { DeliveryService } from './api/delivery.service';
import { DeliveryPayingService } from './api/deliveryPaying.service';
import { DeliveryReceiptService } from './api/deliveryReceipt.service';
import { DeliveryTurnService } from './api/deliveryTurn.service';
import { HomeService } from './api/home.service';
import { ItemService } from './api/item.service';
import { ItemCategoryService } from './api/itemCategory.service';
import { NotificationService } from './api/notification.service';
import { OfferService } from './api/offer.service';
import { OptionalService } from './api/optional.service';
import { OrderService } from './api/order.service';
import { OrderItemService } from './api/orderItem.service';
import { PageService } from './api/page.service';
import { PricePerKmDeliveryService } from './api/pricePerKmDelivery.service';
import { RateService } from './api/rate.service';
import { SliderService } from './api/slider.service';
import { StoreService } from './api/store.service';
import { StorePayingService } from './api/storePaying.service';
import { StoreTypeService } from './api/storeType.service';
import { UserService } from './api/user.service';
import { UserAddressService } from './api/userAddress.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AddonService,
    AdminService,
    BannerService,
    CartService,
    CityService,
    DeliveryService,
    DeliveryPayingService,
    DeliveryReceiptService,
    DeliveryTurnService,
    HomeService,
    ItemService,
    ItemCategoryService,
    NotificationService,
    OfferService, 
    OptionalService,
    OrderService,
    OrderItemService,
    PageService,
    PricePerKmDeliveryService,
    RateService,
    SliderService,
    StoreService,
    StorePayingService,
    StoreTypeService,
    UserService,
    UserAddressService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<any> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
